import React from "react";
import "./Skills.css";

function Skills() {
  const languages = [
    { name: "JavaScript", percent: 100 },
    { name: "TypeScript", percent: 90 },
    { name: "HTML", percent: 75 },
    { name: "Solidity", percent: 60 },
    { name: "CSS", percent: 50 },
  ];

  const frameworksAndLibraries = [
    { name: "Phaser3", percent: 100 },
    { name: "Pixi.js", percent: 100 },
    { name: "Socket.IO", percent: 100 },
    { name: "Express.js", percent: 100 },
    { name: "ApacheCordova", percent: 100 },
    { name: "Truffle.js", percent: 95 },
    { name: "Web3.js", percent: 90 },
    { name: "React.js", percent: 80 },
  ];

  const tools = [
    { name: "VisualStudio", percent: 90 },
    { name: "Git", percent: 80 },
    { name: "Gimp", percent: 80 },
    { name: "Inkscape", percent: 80 },
    { name: "Docker", percent: 70 },
    { name: "AndroidStudio", percent: 50 },
  ];

  return (
    <section className="skills-container" id="skills">
      <div className="skills">
        <div className="page-title">
          <p className="container-title">Skills</p>
          <div className="line"> </div>
        </div>

        <div className="languages">
          <div className="language-title">
            <p className="title">Programming Languages</p>
          </div>

          {languages.map((language, index) => (
            <div
              className="language"
              key={index}
              style={{ width: language.percent + "%" }}
            >
              <div className="name">
                <p>{language.name}</p>
              </div>
              <div className="percent">
                <p className="strong">{language.percent}</p>
              </div>
            </div>
          ))}
        </div>
        <br />
        <br />
        <br />
        <div className="librariesAndFrameworks">
          <div className="language-title">
            <p className="title">Libraries & Frameworks</p>
          </div>

          {frameworksAndLibraries.map((name, index) => (
            <div
              className="language"
              key={index}
              style={{ width: name.percent + "%" }}
            >
              <div className="name">
                <p>{name.name}</p>
              </div>
              <div className="percent">
                <p className="strong">{name.percent}</p>
              </div>
            </div>
          ))}
        </div>
        <br />
        <br />
        <br />
        <div className="tools">
          <div className="language-title">
            <p className="title">Tools</p>
          </div>

          {tools.map((name, index) => (
            <div
              className="language"
              key={index}
              style={{ width: name.percent + "%" }}
            >
              <div className="name">
                <p>{name.name}</p>
              </div>
              <div className="percent">
                <p className="strong">{name.percent}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;
